import { ModelDeclare, ModelProxy } from '@lib/model-proxy';
import { effects } from './effect';
import { OriginKey } from '@interface/index';
import { AGENT_DEPLOY_MODE, AGENT_REGION } from '@config/index';

export interface StateInfo {
  loading: boolean;
  id: string;
  name: string;
  structKey?: OriginKey;
  template?: OriginKey;
  mode: string;
  deployMode?: AGENT_DEPLOY_MODE;
  language: string;
  org: string;
  dirty: boolean;
  description: string;
  privacy: string;
  prApprovalRequired: boolean;
  region: AGENT_REGION;
  icon: string;
  tab: string;
  timeZone?: string;
  knowledgeModel?: string;
  knowledgeKey?: string;
  knowledgeModelName?: string;
  knowledgeURL?: string;
  // llmModels?: LLMModel[];
}

export type PayloadInfo = { [K in keyof StateInfo]: StateInfo[K] };

export const defaultState: PayloadInfo = {
  loading: false,
  id: '',
  dirty: false,
  name: '',
  mode: '',
  language: '',
  org: '',
  description: '',
  privacy: '',
  region: AGENT_REGION.VIRGINIA,
  prApprovalRequired: false,
  icon: '',
  tab: 'general'
};

const agent: ModelDeclare = {
  effects,
  namespace: 'composite',
  state: defaultState,
  actions: {
    clear: () => defaultState
  }
};

export const agentModal = new ModelProxy<StateInfo, PayloadInfo>(agent);
